import { ISimilarState, TModelType } from '../../../store/similar';

export function hasWithoutCompetitors(similarOffers: ISimilarState): boolean {
  return Object.keys(similarOffers).some((modelType: TModelType) =>
    Boolean(similarOffers[modelType].withoutCompetitors),
  );
}
